import { render, staticRenderFns } from "./AmendmentFilesDetails.vue?vue&type=template&id=fb479e70&scoped=true&"
import script from "./AmendmentFilesDetails.vue?vue&type=script&lang=js&"
export * from "./AmendmentFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./AmendmentFilesDetails.vue?vue&type=style&index=0&id=fb479e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb479e70",
  null
  
)

export default component.exports